interface IFieldNames {
  label?: string;
  value?: string;
}

const convertToLabelValueCbb = (data: any[], fieldNames?: IFieldNames) => {
  const { label = 'name', value = 'id' } = fieldNames || {};

  return data.map((item) => ({
    label: `${item[value]} - ${item[label]}`,
    value: item[value],
    id: item.id,
  }));
};

export default convertToLabelValueCbb;
